import request from '@/utils/request.js';
import { tg_sort_ASCII } from '@/utils';

// - 获取活动全局配置信息
export const actInfoApi = (overall_id) =>
  request({
    url: `/v1/limited_time_reward/act_info/${overall_id}`,
    method: 'get',
  });

// - 获取当前用户状态
export const userInfoApi = (overall_id) =>
  request({
    url: `/v1/limited_time_reward/user_info/${overall_id}`,
    method: 'get',
  });


//- 获取活动全局配置下的游戏会场配置 - 首页最多展示5个
export const firstPageApi = (overall_id) =>
  request({
    url: `/v1/limited_time_reward/game_list_first_page/${overall_id}`,
    method: 'get',
  });

// - 获取活动全局配置下的游戏会场配置 - 更多游戏
export const moreGameApi = (overall_id) =>
  request({
    url: `/v1/limited_time_reward/game_list_more/${overall_id}`,
    method: 'get',
  });

// - 获取游戏会场配置下的福利配置
export const welfareApi = (overall_id, params) =>
  request({
    url: `/v1/limited_time_reward/game_welfare_list/${overall_id}`,
    method: 'get',
    params
  });

// - - 领取福利
export const getWelfareApi = (overall_id, data) =>
  request({
    url: `/v1/limited_time_reward/get_welfare/${overall_id}`,
    method: 'post',
    data
  });

// - 礼包领取记录
export const receiveApi = (overall_id, params) =>
  request({
    url: `/v1/limited_time_reward/welfare_user_receive/${overall_id}`,
    method: 'get',
    params
  });

// - 活动推文
export const tweetApi = (overall_id) =>
  request({
    url: `/v1/limited_time_reward/tweet_list/${overall_id}`,
    method: 'get'
  });

// - 埋点上报
export const burnReport = (data) =>
  request({
    url: `/v1/report/data`,
    method: 'post',
    data
  });
